import React, { useState } from 'react'
import { Col, Badge, Modal, Button } from 'react-bootstrap'
import { FaTimes } from 'react-icons/fa'
import CreatableSelect from 'react-select/creatable'

interface Props {
    allowedDomains: string[]
    onAdd(domains: string[]): void
}

const DomainSettings: React.FC<Props> = ({ allowedDomains, onAdd }) => {
    const [showError, setShowError] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    // Funktion til at rydde inputtet til kun domæne
    const cleanDomain = (input: string) => {
        try {
            // Tilføj protokol, hvis ikke allerede, så URL parseren kan arbejde
            const url = input.startsWith('http') ? input : `https://${input}`
            const parsed = new URL(url)
            return parsed.hostname.toLowerCase() // Returner kun hostname uden subpath
        } catch {
            return null
        }
    }

    // Tjekker om en string ligner et domæne
    const isValidDomain = (domain: string) => {
        // Simpel regex til domæner: kan udvides
        return /^[a-z0-9.-]+\.[a-z]{2,}$/i.test(domain)
    }

    const addDomain = (option: any) => {
        const value = option?.value?.trim()?.toLowerCase()
        if (!value) return

        const domain = cleanDomain(value)
        if (!domain || !isValidDomain(domain)) {
            setErrorMessage(`"${value}" er ikke et gyldigt domæne.`)
            setShowError(true)
            return
        }

        if (allowedDomains.includes(domain)) return

        onAdd([...allowedDomains, domain])
    }

    const remove = (domain: string) =>
        onAdd(allowedDomains.filter(d => d !== domain))

    return (
        <Col xs={12} md={6} className="mb-4">
            <h5>Allowed Domains</h5>
            <p className="text-muted">
                Domains where your script is allowed to run.
            </p>

            <CreatableSelect
                placeholder="Type domain…"
                isClearable
                formatCreateLabel={v => `Add "${v}"`}
                onChange={addDomain}
                onCreateOption={value => addDomain({ value })}
            />

            <div className="d-flex flex-wrap gap-2 mt-3">
                {allowedDomains.map(domain => (
                    <Badge
                        key={domain}
                        bg="info"
                        className="d-flex align-items-center px-2 py-1"
                    >
                        {domain}
                        <FaTimes
                            className="ms-2"
                            style={{ cursor: 'pointer' }}
                            onClick={() => remove(domain)}
                        />
                    </Badge>
                ))}
            </div>

            {/* Error Modal */}
            <Modal show={showError} onHide={() => setShowError(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Invalid Domain</Modal.Title>
                </Modal.Header>
                <Modal.Body>{errorMessage}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowError(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Col>
    )
}

export default DomainSettings
